module.exports = __webpack_public_path__ + "img/up_qa.3ee0d7bf.svg";